import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { faTag } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// manor
import { Typography } from '@comparethemarketau/manor-typography';

import { DiscountOfferTermsLink } from './discount_offer_terms_link';
import { withQuoteFlatten } from './with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    discountOfferContainer: {
        width: '90%',
        lineHeight: theme.lineHeight.tighter,
        textAlign: 'center'
    },
    discountOfferText: {
        fontSize: theme.fontSize.xs,
        marginRight: theme.spacing[4]
    },
    tagIcon: {
        marginRight: theme.spacing[4],
        color: theme.colors.primary500
    },
    moreLink: {
        fontSize: theme.fontSize.xs,
        fontWeight: theme.fontWeight.semibold,
        display: 'inline-block'
    }
}));

const _DiscountOffer = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { productDiscountOffer, quote, providerCode } = props;

    const getText = () => {
        if (!productDiscountOffer || !productDiscountOffer.trim()) return null;
        return productDiscountOffer.trim().endsWith('.') ? productDiscountOffer.trim() : productDiscountOffer.trim().concat('.');
    };

    const termsLinkText = isDefaultTextDiscountOffer(providerCode) ? 'More info' : productDiscountOffer;

    return (
        productDiscountOffer ? (
            <div className={classes.discountOfferContainer}>
                <span>
                    <FontAwesomeIcon icon={faTag} size="xs" className={classes.tagIcon} />
                    {
                        isDefaultTextDiscountOffer(providerCode) && (
                            <Typography display="inline" className={classes.discountOfferText}>
                                {
                                    getText()
                                }
                            </Typography>
                        )
                    }
                    <DiscountOfferTermsLink quote={quote}>
                        <Typography className={classes.moreLink}>
                            {termsLinkText}
                        </Typography>
                    </DiscountOfferTermsLink>
                </span>
            </div>
        ) : null
    );
};

_DiscountOffer.propTypes = {
    quote: PropTypes.object,
    providerCode: PropTypes.string,
    productDiscountOffer: PropTypes.string
};

const DiscountOffer = withQuoteFlatten(_DiscountOffer);

// created for KOBA, but since business needs have changed.
const isDefaultTextDiscountOffer = (providerCode) => providerCode !== 'OTHER';

export { DiscountOffer, _DiscountOffer, isDefaultTextDiscountOffer };
